module.exports = __webpack_public_path__ + "static/media/Megan Hernandez Headshot.8e7fa38f.jpeg";